import { FC } from 'react';
import TrainingRequestList from '../../components/digital-office/training-requests/TrainingRequestList';

const TrainingRequestsListPage: FC = () => {
  return <TrainingRequestList />;
};

export default TrainingRequestsListPage;
